import React from "react";
import SolutionCard from './CardSolution'
import "../../styles/solution/Solution.css";
import { useTranslation } from "react-i18next";
import cameraEmbarque from '../../assets/images/Solutions/car-camera-icon.png';

export default function Solution(props) {

  const {t} = useTranslation();
  const cardContent = [
    {
      "id": 1,
      "title": t('Solutions.Géolocalisation'),
      "description": t('Solutions.Géolocalisation_desc'),
      "icon": "fa fa-map-marked fa-5x icon"
    },
    {
      "id": 2,
      "title": t('Solutions.flottes'),
      "description": t('Solutions.flottes_desc'),
      "icon": "fa-solid fa-car"
    },  
    {
      "id": 3,
      "title": t('Solutions.Controle'),
      "description": t('Solutions.Controle_desc'),
      "icon": "icon fa fa-gas-pump fa-5x",
    },
    {
      "id": 4,
      "title": t('Solutions.antivol'),
      "description": t('Solutions.antivol_desc'),
      "icon": "fa fa-shield-alt icon fa-5x"
    },
    {
      "id": 5,
      "title": "Comportement des conducteurs",
      "description": t('Solutions.Comportement_desc'),
      "icon": "fa fa-car-crash icon fa-5x"
    }
  ]
  
  return (
    <div className="Solotion--container" ref={props.solutionRef}>
    <div className="line"><h1 className="Solution-Title">{t('Solutions.title')} <span className="SpanHighlightBlue">Solutions</span></h1></div>
    <div className="card--content">
      {
        cardContent.map((card)=> <SolutionCard title={card.title} description={card.description} icon={card.icon} image={card.image} key={card.id}/> )
      }
      <div className="solution-card-container" data-aos="fade-up">
      <div className='card-header'>
          <div className='icon'>
            <span className='blob'>
              <img src={cameraEmbarque} alt="Camera embarquée" />
            </span>
          </div>
          <span className='title'><h1>{t('Solutions.camera')}</h1></span>
       </div>
       <div className='card-body'>
       <p>{t('Solutions.camera_desc')}</p>
       </div>
        </div>
    </div>
     
    </div>
  );
}
